import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import OffersV4Headline from './OffersV4Headline';
import OffersV4CardList from './OffersV4CardList';
import OffersV4LoanOfferDetails from './OffersV4LoanOfferDetails';
import OffersV4StickyCta from './OffersV4StickyCta';
import OffersV4ValueProps from './OffersV4ValueProps';
import OffersV4SocialProof from './OffersV4SocialProof';
import OffersV4Disclosure from './OffersV4Disclosure';
import OffersV4HelpContact from './OffersV4HelpContact';
import CreditCardReductionBanner from '../../banners/CreditCardReductionBanner';

const OffersV4MobileLayout = ({
    maxOffer,
    minOffer,
    sliderAmount,
    selectedOfferId,
    isSelectingOffer,
    offersAtAmount,
    guidanceTags,
    counterOffer,
    counterOfferReportChanged,
    onAmountChange,
    onCardSelect,
    onContinue,
    onEditClick,
    isDialogOpen,
    onDialogClose,
    onDialogSubmit,
}) => (
    <Fragment>
        <CreditCardReductionBanner />
        <div className="offers-v4-page">
            <div className="offers-v4-content">
                <OffersV4Headline
                    maxOffer={maxOffer}
                    counterOffer={counterOffer}
                    counterOfferReportChanged={counterOfferReportChanged}
                />
                <OffersV4LoanOfferDetails
                    amount={sliderAmount}
                    minOffer={minOffer}
                    maxOffer={maxOffer}
                    onAmountChange={onAmountChange}
                    onEditClick={onEditClick}
                    isDialogOpen={isDialogOpen}
                    onDialogClose={onDialogClose}
                    onDialogSubmit={onDialogSubmit}
                />
                <OffersV4CardList
                    offers={offersAtAmount}
                    guidanceTags={guidanceTags}
                    selectedOfferId={selectedOfferId}
                    onSelect={onCardSelect}
                />
                <OffersV4ValueProps />
                <OffersV4SocialProof />
                <OffersV4Disclosure />
                <OffersV4HelpContact />
            </div>
        </div>
        <OffersV4StickyCta
            onContinue={onContinue}
            disabled={!selectedOfferId || isSelectingOffer}
            loading={isSelectingOffer}
        />
    </Fragment>
);

OffersV4MobileLayout.propTypes = {
    maxOffer: PropTypes.number.isRequired,
    minOffer: PropTypes.number.isRequired,
    sliderAmount: PropTypes.number.isRequired,
    selectedOfferId: PropTypes.string,
    isSelectingOffer: PropTypes.bool.isRequired,
    offersAtAmount: PropTypes.array.isRequired,
    guidanceTags: PropTypes.object.isRequired,
    counterOffer: PropTypes.bool,
    counterOfferReportChanged: PropTypes.bool,
    onAmountChange: PropTypes.func.isRequired,
    onCardSelect: PropTypes.func.isRequired,
    onContinue: PropTypes.func.isRequired,
};

export default OffersV4MobileLayout;
